<template>
    <div class="payment">
        <div class="header-message-toolbar">
            <div class="header-bar">
                <div class="back" @click="$router.go(-1)">
                    <ion-icon name="md-arrow-back"></ion-icon>
                </div>
                <div class="title">
                    <span>결제하기</span>
                </div>
            </div>
            <div class="message">
            </div>
        </div>

        <div class="content">
            <div class="payout">
                <div class="price-total-label color-orange top"><span>최종 결제금액</span><span>{{ payment.payment_amount.toLocaleString() }}원</span></div>
                <div class="price-sub-total">
                    <div class="price-main-label"><span>{{ payment.product_title }}</span><span>{{ payment.payment_amount_orgin.toLocaleString() }}원</span></div>
                    <div class="price-discount-label align-center" v-if="useDiscount"><div class="align-center"><img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/main/renewal-2021-09-30/minus-image.png" style="height: 1.2em;"><span class="ml-1">장기 약정 할인</span></div><span>-{{ payment.payment_amount_disc.toLocaleString() }}원</span></div>
                    <div class="price-discount-label align-center" v-if="useCoupon"><div class="align-center"><img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/main/renewal-2021-09-30/minus-image.png" style="height: 1.2em;"><span class="ml-1">쿠폰 할인</span></div><span>-{{ payment.payment_amount_coupon.toLocaleString() }}원</span></div>
                </div>
                <div class="price-sub-total2">
                    <div class="price-total-label bottom"><span>총 결제금액</span><span class="color-orange">{{ payment.payment_amount.toLocaleString() }}원</span></div>
                </div>
            </div>

            <div class="item-group mt-5">
                <span class="input-title">할인쿠폰</span>
                <div class="checked-comment mt-1">
                    <span class="item-info">쿠폰번호는 16자리 숫자로 이루어져 있습니다.<br>쿠폰에 표기된 유효기간을 꼭 확인하세요.</span>
                </div>
                <div class="input-group">
                    <input class="no-outline" type="text" placeholder="16자리 쿠폰번호 입력" v-model="coupon_number" />
                    <ion-button class="basic" mode="ios" expand="block" fill="outline" shape="round" size="small" color="primary" v-bind:disabled="coupon_number === ''" @click="getDiscountInfo">쿠폰확인</ion-button>
                </div>
            </div>

            <div class="item-group mt-4">
                <span class="input-title" hidden>결제수단 선택</span>
                <div class="checked-comment" hidden>
                    <div class="payment-description ml-3" style="color: #666666;">
                        <div class="format1"><span class="mark">*</span>6개월/12개월 약정결제자는, <span class="text-danger">신용카드 결제 시</span> 매월 분할하여 자동 결제가 가능합니다. (무이자)</div>
                        <div class="format1"><span class="mark">∙</span>6개월 결제 시: 매월 69,000원 자동결제 (무이자/6회납부)</div>
                        <div class="format1"><span class="mark">∙</span>12개월 결제 시: 매월 59,000원 자동결제 (무이자/12회납부)</div>
                        <div class="format1 text-danger"><span class="mark">*</span>가상계좌 이체 시 반드시 고객센터로 전화해주시기 바랍니다.(고객센터 02-540-4905)</div>
                    </div>
                    <!--                <div class="item-icon">-->
                    <!--                    <ion-icon name="ios-information-circle-outline" color="azure"></ion-icon>-->
                    <!--                </div>-->
                    <!--                <span class="item-info"><font>듣는동화의 정기결제 해지는</font><br> APP 접속 > MY페이지 > 이용권 에서 가능합니다.</span>-->
                </div>

                <div class="payment2-list mt-3">
                    <div class="check-box" v-bind:class="{'selected_type' : (payment.payment_method === '10') }" @click="onclickPayment('10')">
                        <div class="item-image">
                            <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/main/renewal-2021-09-30/pay_method_card.png" />
                        </div>
                        <div class="item-label">신용카드</div>
                    </div>
                    <div class="check-box" v-bind:class="{'selected_type' : (payment.payment_method === '20') }" @click="onclickPayment('20')">
                        <!--                <div class="check-box" v-show="payment.product_no !== 'P0001'" v-bind:class="{'selected_type' : (payment.payment_method === '20') }" @click="serviceAlert()">-->
                        <div class="item-image">
                            <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/main/renewal-2021-09-30/pay_method_phone.png" />
                        </div>
                        <div class="item-label">휴대전화</div>
                    </div>
                    <div class="check-box" v-bind:class="{'selected_type' : (payment.payment_method === '30') }" @click="onclickPayment('30')">
                        <div class="item-image">
                            <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/main/renewal-2021-09-30/pay_method_wallet.png" />
                        </div>
                        <div class="item-label">가상계좌</div>
                    </div>
                </div>
            </div>

<!--            <div class="checked-agree" @click="onAgree">-->
<!--                <div class="item-icon">-->
<!--                    <ion-icon v-bind:color="payment.agree ? 'primary' : 'medium'" name="ios-checkmark-circle"></ion-icon>-->
<!--                </div>-->
<!--                <div class="item-info">-->
<!--                    <span>이용약관 및 하단 유의사항에 동의합니다.</span>-->
<!--                </div>-->
<!--            </div>-->
        </div>

        <form id="paymentOrder" method="post" style="display: none;" >
            <input type="text" name="orderNo" />
            <input type="text" name="payType" />
            <input type="text" name="productNm" />
            <input type="text" name="productAmt" />
            <input type="text" name="userId" />
            <input type="text" name="membUserNo" />
            <input type="text" name="userName" />
            <input type="text" name="userEmail" />
            <input type="text" name="userPhone1" />
            <input type="text" name="userPhone2" />
            <input type="text" name="vacctEndDate" />
            <input type="text" name="vacctEndTime" />
            <input type="text" name="installPeriod" />
            <input type="submit" value="submit" />
        </form>

        <footer-two-buttonbar left-label="나중에" right-label="결제하기" v-bind:is-fixed="true" v-bind:disabled="isNextButtonDisabled" v-on:leftButtonEvent="leftClickEvent" v-on:rightButtonEvent="rightClickEvent" />
    </div>
</template>

<script>
    import Vue from 'vue';
    import * as ajax from '../../utils/ajax'
    import * as alert from '../../utils/alert';
    import FooterTwoButtonbar from "../../components/footer/FooterTwoButtonbar";
    import * as utils from "../../utils/utils";
    import * as biz from "../../utils/biz";
    import RepeatPaymentIntroduceModal from "./RepeatPaymentIntroduceModal";

    export const eventBus = new Vue();

    export default {
        name: 'Payment',
        components: {FooterTwoButtonbar},
        props: {
            productNo: String
        },
        data() {
            return {
                coupon_number: "",
                customTokens: {
                    mask: 'XXXX-XXXX-XXXX-XXXX',
                    tokens: {
                        'X': {
                            pattern: /[0-9a-zA-Z]/,
                            transform: function(v) {
                                return v.toLocaleUpperCase();
                            }
                        }
                    }
                },
                payment: {
                    product_no: '',
                    product_title: '',
                    payment_amount: 0,
                    payment_month: 1,
                    payment_amount_src: 0,
                    payment_amount_orgin: 0,
                    payment_amount_disc: 0,
                    payment_amount_coupon: 0,
                    payment_method: '',
                    agree: true
                },
                member: {},
                firstTicket: {},
                ticketList: [],
                useDiscount: false,
                useCoupon: false,
            }
        },
        created() {
            // PG 결제페이지에서 뒤로 가기 눌렀을때 이용권페이지로 이동
            if (this.productNo === undefined) {
                this.$router.replace("/mypage/ticket");
                return;
            }

            this.$store.state.basicPlayerVisiblity = false;
            this.payment.product_no = this.productNo;

            ajax.Get(this, "/api/product/product/info?product_no="+this.productNo, function(ref, data) {

                switch(data.product_no) {
                    case "P0011": {
                        ref.payment.product_title = '관리형 ' + data.product_name;
                        ref.payment.payment_amount = 35000;
                        ref.payment.payment_month = 1;
                        ref.payment.payment_amount_src = 35000;
                        ref.payment.payment_amount_orgin = 35000;
                        ref.useDiscount = false;
                        break;
                    }
                    case "P0012": {
                        ref.payment.product_title = '관리형 ' + data.product_name;
                        ref.payment.payment_amount = 79000;
                        ref.payment.payment_month = 3;
                        ref.payment.payment_amount_src = 79000;
                        ref.payment.payment_amount_orgin = 79000;
                        ref.useDiscount = true;
                        break;
                    }
                    case "P0013": {
                        ref.payment.product_title = '관리형 ' + data.product_name;
                        ref.payment.payment_amount = 115000;
                        ref.payment.payment_month = 6;
                        ref.payment.payment_amount_src = 115000;
                        ref.payment.payment_amount_orgin = 115000;
                        ref.useDiscount = true;
                        break;
                    }
                       case "P0014": {
                        ref.payment.product_title = '관리형 ' + data.product_name;
                        ref.payment.payment_amount = 199000;
                        ref.payment.payment_month = 12;
                        ref.payment.payment_amount_src = 199000;
                        ref.payment.payment_amount_orgin = 199000;
                        ref.useDiscount = true;
                        break;
                    }
                    case "P0020": {
                        ref.payment.product_title = data.product_name;
                        ref.payment.payment_amount = 1900;
                        ref.payment.payment_month = 1;
                        ref.payment.payment_amount_src = 1900;
                        ref.payment.payment_amount_orgin = 1900;
                        ref.useDiscount = false;
                        break;
                    }
                }
                ref.useCoupon = false;
                ref.payment.payment_amount_coupon = 0;
                ref.payment.payment_amount_disc = ref.payment.payment_amount_orgin - ref.payment.payment_amount_src;
            });

            eventBus.$on('agreement', this.submitForm);
        },
        async mounted() {
            await ajax.Get(this, "/api/member/member/", function(ref, data) {
                ref.member = data;
            });
            await ajax.Get(this, "/api/product/ticket/my", function(ref, data) {
                ref.ticketList = data;
                if (ref.ticketList[0]) {
                    ref.firstTicket = ref.ticketList[0];
                    console.log("coupons = "+JSON.stringify(ref.firstTicket));
                }
            });
        },
        methods: {
            getDiscountInfo() {
                const params = {
                    coupon_div: '20',
                    unique_no: String(this.coupon_number).replace(/-/gi, "")
                };
                ajax.Post(this, "/api/product/coupon/discountinfo", params, function(ref, data) {
                    console.log('get salecoupon :' + JSON.stringify(data));
                    if (data != null) {
                        if (data.period_unit === "RATE") {
                            ref.useCoupon = true;
                            ref.payment.payment_amount_coupon = (ref.payment.payment_amount_src*data.period/100);
                            ref.payment.payment_amount = ref.payment.payment_amount_src-ref.payment.payment_amount_coupon;
                        } else {
                            ref.useCoupon = true;
                            ref.payment.payment_amount = ref.payment.payment_amount_src*((100-data.period)/100);
                        }
                    } else {
                        ref.useCoupon = true;
                        this.coupon_number = "";
                    }
                });
            },
            onclickPayment(payment_method) {
                this.payment.payment_method = payment_method;
            },
            serviceAlert() {
                alert.alert("서비스를 준비중입니다", "확인");
            },
            onAgree() {
                this.payment.agree = !this.payment.agree;
            },
            leftClickEvent() {
                this.$router.push("/mypage/main");
            },
            rightClickEvent() {
                var self = this;
                if (this.payment.payment_method === '30') {
                    alert.alert('가상계좌 이체 시 반드시 고객센터로 전화해주시기 바랍니다.(고객센터 02-540-4905)', '확인', null, function() {
                        self.submitForm();
                    });
                } else if (this.payment.payment_method === '10' && (this.payment.product_no === 'P0012' || this.payment.product_no === 'P0013')) {
                    if (this.firstTicket && this.firstTicket.use_end_date) {
                        alert.alert("신용카드에 의한 정기이용권 구매는 현재 학습 중인 이용권이 종료된 후 구매 가능합니다.\n현재 진행 중인 이용권의 학습 기간이 남아있음으로 학습 기간이 종료되면, 결제 부탁드립니다.", "확인");
                        return;
                    }

                    return self.$ionic.modalController
                        .create({
                            component: RepeatPaymentIntroduceModal,
                            componentProps: {
                                propsData: {
                                },
                                data: {
                                }
                            },
                        }).then(m => m.present())
                } else {
                    this.submitForm();
                }
            },
            submitForm() {
                // 주문요청
                const params = {
                    product_no: this.payment.product_no,
                    payment_method: this.payment.payment_method,
                    payment_amount: this.payment.payment_amount / this.payment.payment_month,
                    unique_no: String(this.coupon_number).replace(/-/gi, "")
                };
                ajax.Post(this, "/api/product/payment/", params, function(ref, data) {
                    let action = process.env.VUE_APP_PAYMENT_URI;
                    let payType = "";
                    switch (ref.payment.payment_method) {
                        case "10":
                            payType = "11";
                            // 6개월 12개월 결제인 경우에는 카드 등록 페이지에로 이행
                            if (ref.payment.product_no == "P0012" || ref.payment.product_no == "P0013")
                                action = process.env.VUE_APP_CERT_URI;
                            break;
                        case "20":
                            payType = "31";
                            break;
                        case "30":
                            payType = "22";
                            break;
                    }

                    // form 은 binding 은 되나 submit 시에 전달이 안됨.
                    // 왜일까?
                    document.getElementById("paymentOrder").setAttribute("action", action);

                    document.querySelector("form input[name='orderNo']").value = data.order_no;
                    document.querySelector("form input[name='payType']").value = payType;
                    document.querySelector("form input[name='productNm']").value = ref.payment.product_title;
                    document.querySelector("form input[name='productAmt']").value = ref.payment.payment_amount;
                    document.querySelector("form input[name='userId']").value = ref.member.member_id;
                    document.querySelector("form input[name='membUserNo']").value = ref.member.member_no;
                    // 학생일 경우에는 부모명으로
                    document.querySelector("form input[name='userName']").value = ref.member.member_div === "10" ? ref.member.parent_name : ref.member.member_name;
                    document.querySelector("form input[name='userEmail']").value = ref.member.email;
                    document.querySelector("form input[name='userPhone1']").value = ref.member.tel;
                    document.querySelector("form input[name='userPhone2']").value = ref.member.tel;
                    document.querySelector("form input[name='vacctEndDate']").value = ref.payment.payment_method === "30" ? String(data.deposit_deadline).substring(0, 8) : "";
                    document.querySelector("form input[name='vacctEndTime']").value = ref.payment.payment_method === "30" ? String(data.deposit_deadline).substring(8, 14) : "";

                    // console.log( document.querySelector("form input[name='orderNo']").value );
                    // console.log( document.getElementById("paymentOrder").outerHTML );

                    // console.log(ref.member.member_div);
                    // console.log(ref.member.member_name);
                    // console.log(ref.member.parent_name);
                    // console.log(document.querySelector("form input[name='userName']").value);

                    document.getElementById("paymentOrder").submit();
                });
            }
        },
        computed: {
            isNextButtonDisabled() {
                return !(this.payment.agree && this.payment.payment_method !== '');
            }
        }
    }
</script>

<style scoped lang="scss">
    .payment {
        overflow-y: auto;
        min-height: 100vh;

        div.content {
            margin: 0 24px 80px;

            div.checked-comment {
                display: flex;
                margin: 14px 0 22px 0;
                text-align: justify;
                font-size: $font-base13;

                .item-icon {
                    margin-right: 5px;
                    font-size: $font-base14;
                    color: $font-fifth-color;
                }
                .item-info {
                    flex: auto;
                    color: $font-third-color;

                    font {
                        color: $font-fifth-color;
                    }
                }
            }

            div.checked-agree {
                margin-top: 18px;
                font-size: $font-base12;
                vertical-align: center;
                display: flex;

                div.item-icon {
                    width: 22px;
                    font-size: $font-base20;
                    margin-right: 6px;
                }
                div.item-info {
                    flex: auto;
                    padding-top: 6px;
                    font-size: $font-base12;
                }
            }

            .payout {
                margin-top: 3em;
                border: 1px solid $line-secondary-color;
                border-radius: 10px;

                .color-orange {
                    color: $primary-color;
                }
                .price-total-label {
                    font-size: 1.2em;
                    font-weight: 500;
                    display: flex;
                    justify-content: space-between;

                    &.top {
                        padding: 20px 30px;
                        border-bottom: 1px solid $line-secondary-color;
                    }

                    &.bottom {
                        padding: 20px 0px;
                        border-top: 1px solid $line-secondary-color;
                        font-size: 1.1em;
                    }
                }
                .price-sub-total2 {
                    padding: 0px 30px;
                }

                .price-sub-total {
                    height: 120px;
                    padding: 0px 30px;

                    .price-main-label {
                        display: flex;
                        font-weight: 500;
                        padding: 20px 10px 10px;
                        justify-content: space-between;
                    }

                    .price-discount-label {
                        border-top: 1px dotted $line-secondary-color;
                        display: flex;
                        font-size: $font-base13;
                        font-weight: 500;
                        color: $font-fifth-color;
                        padding: 10px 10px;
                        justify-content: space-between;
                    }
                }
            }

            div.item-group {
                margin: 15px 0 25px 0;

                div.payment2-list {
                    list-style: none;
                    margin: 0;
                    padding: 0;
                    overflow: hidden;
                    display: grid;
                    grid-gap: 1em;
                    grid-template-columns: 1fr 1fr 1fr;

                    div.check-box {
                        text-align: center;
                        border: 1px solid $line-secondary-color;
                        flex: 0 0 33.3%;
                        padding: 20px 0 10px;
                        border-radius: 10px;

                        div.item-image {
                            margin: 0 auto;
                            width: 50px;
                            height: 50px;

                            img {
                                max-width: 100%;
                                max-height: 100%;
                                vertical-align: middle;
                            }
                            span {
                                font-size: $font-base14;
                            }
                        }
                        div.item-label {
                            margin-top: 1em;
                        }
                    }
                    div.selected_type {
                        background: #f3f3f3;
                    }
                }

                span.input-title {
                    font-weight: $font-weight500;
                }

                div.input-group {
                    margin-top: 6px;
                    padding: 5px 10px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    border: 1px solid $line-secondary-color;
                    border-radius: 5px;

                    input.no-outline {
                        width: 100%;
                    }
                    ion-button {
                        width: 65px;
                        height: 23px;
                    }

                    // radio button
                    div.radio-group {
                        display: flex;
                    }
                }
            }
        }
    }
    .align-center {
        display: flex;
        align-items: center;
        align-content: center;
    }
</style>
